import { load } from './load';

export default load({
  "!": "··",
  "(": "⁖",
  ")": "჻",
  ".": "։",
  "...": "···",
  ":": "⸬",
  ";": "⁘",
  "?": ";",
  "\"": "⸪",
  "a": "ⰰ",
  "b": "ⰱ",
  "c": "ⱌ",
  "ce": "ⱌⰵ",
  "ch": "ⱈ",
  "che": "ⱈⰵ",
  "chie": "ⱈⰺⰵ",
  "ci": "ⱅⰻ",
  "cia": "ⱅⱝ",
  "cie": "ⱅⰵ",
  "cio": "ⱅⱖ",
  "ciu": "ⱅⱓ",
  "cja": "ⱌⰺⰰ",
  "cje": "ⱌⰺⰵ",
  "cji": "ⱌⰺⰻ",
  "cjo": "ⱌⰺⱁ",
  "cju": "ⱌⰺⱆ",
  "cją": "ⱌⰺⱘ",
  "cję": "ⱌⰺⱔ",
  "cz": "ⱍ",
  "cze": "ⱍⰵ",
  "d": "ⰴ",
  "dz": "ⰷ",
  "dze": "ⰷⰵ",
  "dzi": "ⰴⰻ",
  "dzia": "ⰴⱝ",
  "dzie": "ⰴⰵ",
  "dzio": "ⰴⱖ",
  "dziu": "ⰴⱓ",
  "dzią": "ⰴⱘ",
  "dzię": "ⰴⱔ",
  "dź": "ⰴⱐ",
  "e": "꙼ⰵ",
  "f": "ⱇ",
  "g": "ⰳ",
  "h": "ⱒ",
  "he": "ⱒⰵ",
  "hie": "ⱈⰺⰵ",
  "i": "ⰻ",
  "ia": "ⱝ",
  "ie": "ⰵ",
  "io": "ⱖ",
  "iu": "ⱓ",
  "iy": "ⰺⰹⱏ",
  "ią": "ⱙ",
  "ię": "ⱗ",
  "j": "ⰹ",
  "ja": "ⱝ",
  "je": "ⰵ",
  "jo": "ⱖ",
  "ju": "ⱓ",
  "jy": "ⰺⰹⱏ",
  "ją": "ⱙ",
  "ję": "ⱗ",
  "k": "ⰽ",
  "l": "ⰾⱐ",
  "la": "ⰾⱝ",
  "le": "ⰾⰵ",
  "li": "ⰾⰻ",
  "lo": "ⰾⱖ",
  "lu": "ⰾⱓ",
  "ló": "ⰾⱖ̄",
  "lą": "ⰾⱙ",
  "lę": "ⰾⱗ",
  "m": "ⰿ",
  "n": "ⱀ",
  "o": "ⱁ",
  "p": "ⱂ",
  "r": "ⱃ",
  "ri": "ⱃ꙼ⰻ",
  "rz": "ⱃⱐ",
  "rza": "ⱃⱝ",
  "rze": "ⱃⰵ",
  "rzo": "ⱃⱖ",
  "rzu": "ⱃⱓ",
  "rzy": "ⱃⰻ",
  "rzą": "ⱃⱙ",
  "rzę": "ⱃⱗ",
  "s": "ⱄ",
  "sja": "ⱄⰺⰰ",
  "sje": "ⱄⰺⰵ",
  "sji": "ⱄⰺⰻ",
  "sjo": "ⱄⰺⱁ",
  "sju": "ⱄⰺⱆ",
  "sją": "ⱄⰺⱘ",
  "sję": "ⱄⰺⱔ",
  "sz": "ⱎ",
  "sze": "ⱎⰵ",
  "t": "ⱅ",
  "u": "ⱆ",
  "w": "ⰲ",
  "y": "ⱏⰹ",
  "yj": "ⱏⰹⰺ",
  "z": "ⰸ",
  "|": "⁞",
  "ó": "ⱁ̄",
  "ą": "ⱘ",
  "ć": "ⱅⱐ",
  "ę": "ⱔ",
  "ł": "ⰾ",
  "ń": "ⱀⱐ",
  "ś": "ⱄⱐ",
  "ź": "ⰸⱐ",
  "ż": "ⰶ",
  "że": "ⰶⰵ",
  "…": "···",
});

